<script>
  import ClickOut from '../../../utils/directives/clickout'
  import MenuAdminSite from './menu/AdminSite'
  import MenuBI from './menu/BI'
  import { mapState, mapGetters } from 'vuex'
  import ACL from '../../../domain/acl/tmp-acl'

  export default {
    computed: {
      ...mapState({
        menuOpen: state => state.app.menuOpen
      }),
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    mounted () {
      this.popupItem = this.$el
    },
    data () {
      return {}
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        if (this.menuOpen === true) {
          this.$store.commit('APP/SET_TOGGLE_MENU', false)
        }
      }
    },
    components: {
      MenuAdminSite,
      MenuBI
    },
    directives: {ClickOut}
  }
</script>

<template>
  <!-- TODO: Menu com 'app-aside-fixed' não funciona o hover -->
  <div id="aside" class="app-aside hidden-xs bg-black hidden-print " v-click-out="hide" @click="toggle"
       :class="{ 'off-screen': menuOpen }">
    <div class="aside-wrap">
      <div class="navi-wrap">
        <!-- nav -->
        <nav ui-nav class="navi clearfix">
          <ul class="nav">
            <li class="m-t">
              <router-link to="/">
                <i class="fa fa-windows icon text-primary"></i>
                <span>Dashboard</span>
              </router-link>
            </li>
            <li class="hidden-folded padder m-t m-b-sm text-muted text-xs"><span>Apps</span></li>
            <li>
              <router-link :to="{ name: 'arrematantes' }">
                <i class="fa fa-users icon text-info"></i>
                <span>Arrematantes</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'comitentes' }">
                <i class="fa fa-briefcase icon text-success"></i>
                <span>Comitentes</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'documentos' }">
                <i class="icon-docs icon"></i>
                <span>Documentos</span>
              </router-link>
            </li>
            <MenuAdminSite/>

            <li>
              <router-link :to="{ name: 'leilao' }">
                <i class="fa fa-gavel text-warning icon "></i>
                <span>Leilões</span>
              </router-link>
            </li>

            <li ui-sref-active="active">
              <router-link :to="{ name: 'inadimplentes' }">
                <i class="glyphicon glyphicon-check icon text-danger-lter"></i>
                <span class="ng-scope">Inadimplentes</span>
              </router-link>


            <li ui-sref-active="active">
              <router-link :to="{ name: 'impedimentos' }">
                <b class="badge bg-danger pull-right">novo</b>
                <i class="glyphicon glyphicon-ban-circle icon text-danger-lter"></i>
                <span class="ng-scope">COAF</span>
              </router-link>
            </li>

            <li class="line dk hidden-folded"></li>
            <li class="hidden-folded padder m-t m-b-sm text-muted text-xs"><span>Colaborativo</span></li>
            <li v-if="ACL.check('gerenciar_usuario_intranet', currentUser.id)">
              <router-link :to="{name: 'usuarios'}">
                <i class="icon-user icon text-success-lter"></i>
                <span>Usuários</span>
              </router-link>
            </li>
            <li class="hidden-folded padder m-t m-b-sm text-muted text-xs"><span>Estatísticas</span></li>
            <MenuBI/>
            <li>
              <router-link :to="{name: 'relatorios-basico'}">
                <i class="icon-list icon "></i>
                <span>Relatórios Básicos</span>
              </router-link>
            </li>
            <li class="hidden-folded padder m-t m-b-sm text-muted text-xs"><span>Comunicação e Marketing</span></li>
            <li ui-sref-active="active">
              <router-link :to="{ name: 'contatos' }">
                <i class="glyphicon glyphicon-envelope icon text-info-lter"></i>
                <span class="font-bold ng-scope">Atendimento</span>
              </router-link>
            </li>
            <li v-if="ACL.check('rh', currentUser.id)" ui-sref-active="active">
              <router-link :to="{ name: 'trabalhe.conosco.index' }">
                <i class="glyphicon glyphicon-envelope icon text-info-lter"></i>
                <span class="font-bold ng-scope">Trabalhe Conosco</span>
              </router-link>
            </li>
            <li>
              <a href="https://m.rogeriomenezes.com.br" target="_blank">
                <i class="fa fa-location-arrow icon text-primary"></i>
                <span>Automação</span>
              </a>
            </li>
            <li>
              <a @click="$parent.toggleChat()" target="_blank">
                <i class="icon-bubbles icon text-info"></i>
                <span>Chat</span>
              </a>
            </li>
            <!--<li><a href="javascript://"> <i class="glyphicon glyphicon-stats icon"></i> <span>Metas</span> </a></li>-->
            <!--<li><a href="javascript://"> <i class="icon-question icon"></i> <span>Documentos</span> </a></li>-->
          </ul>
        </nav>
        <!-- nav -->

        <!-- menu footer -->
        <div class="wrapper m-t hidden">
          <!-- Metas do mês -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Metas do mês</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-info" style="width: 50%;"></div>
          </div>
          <!-- Metas do dia -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Metas do dia</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-success" style="width: 50%;"></div>
          </div>
          <!-- Leitura de avisos -->
          <div class="text-center-folded"><span class="pull-right pull-none-folded">50%</span> <span
            class="hidden-folded">Leitura dos avisos</span></div>
          <div class="progress progress-xxs m-t-sm dk">
            <div class="progress-bar progress-bar-danger" style="width: 50%;"></div>
          </div>
        </div>
        <!-- / menu footer -->
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Menu.vue?1af76554